const initialState = [];

export default function holidaysReducer(state = initialState, action) {
    switch (action.type) {
        case "FETCH_ALL_HOLIDAYS":
            // payload = array van vakantie entries
            return action.payload || [];

        default:
            return state;
    }
}
